import React, { FC, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks';
import { validateDomainCase } from '../../../shared/validation/domain';
import { createDomain, domainState, listDomains, resetCreatedDomain } from '../domainSlice';
import { CreateDomainInput } from '../models/CreateDomain.interface';
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import { useForm } from "react-hook-form";
import { validateDomainLength } from '../../../shared/validation/length';

const CreateDomainForm: FC = () => {
    const dispatch = useAppDispatch();

    type FormValues = {
        domainName: string;
    };

    const { handleSubmit, setError, formState: { errors }, register } = useForm<FormValues>({
        mode: "onTouched",
        reValidateMode: "onChange"
    });

    const submitHandler = ({ domainName }: FormValues) => {
        const createDomainInput: CreateDomainInput = {
            domain: domainName + ".fromsmash." + process.env.REACT_APP_DOMAIN_EXT,
        };
        dispatch(createDomain(createDomainInput));
    }

    const { list, createdDomain } = useAppSelector(domainState);

    useEffect(() => {
        if (createdDomain.isError) {
            setError("domainName", { type: "custom", message: createdDomain.error?.message });
            dispatch(resetCreatedDomain());
        }
        if (createdDomain.isSuccess) {
            dispatch(resetCreatedDomain());
            dispatch(listDomains());
        }
    }, [createdDomain, list]);

    if (createdDomain.isLoading) {
        return < SmashSpinner />;
    }

    return (
        <>
            <Form id='createDomain-form' noValidate onSubmit={handleSubmit(submitHandler)}>
                <Form.Group className="mb-3" controlId="domainName">
                    <Form.Label>Domain name</Form.Label>
                    <Form.Control
                        {...register('domainName', { required: true, validate: { length: validateDomainLength, case: validateDomainCase  } })}
                        type="text"
                        placeholder="Enter a domain name"
                        isInvalid={!!errors.domainName} />
                
                {errors.domainName?.type === "custom" && (
                    <Form.Control.Feedback type="invalid">
                        {errors.domainName.message}
                    </Form.Control.Feedback>)}
                {errors.domainName?.type === "case" && (
                    <Form.Control.Feedback type="invalid">
                        Domain must only contain lowercase letter, numbers
                    </Form.Control.Feedback>)}
                {errors.domainName?.type === "length" && (
                    <Form.Control.Feedback type="invalid">
                        Domain must contain at least 4 char
                    </Form.Control.Feedback>)}
                </Form.Group>
                {/* <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <Button variant="primary" type="submit">
                        Create
                    </Button>
                </div> */}
            </Form>
        </>
    )
}

export default CreateDomainForm
